import {Component} from '@angular/core';
import {AuthenticationService} from '../../service/authentication.service';
import {Router} from '@angular/router';

// import {Router} from "@angular/router";

@Component({
    template: require('./login.component.html'),
    styles: [require('./login.component.scss')]
})
export class LoginComponent {

    private login: string;
    public loading = false;
    private password: string;
    error: boolean;

    constructor(
        private router: Router,
        private at: AuthenticationService,
    ) {
        this.error = false;
    }

    onSubmit() {
        this.loading = true;
        this.at.login(this.login, this.password)
            .subscribe(() => {
                this.loading = false;
                this.router.navigateByUrl('/postits');
            }, () => {
                this.error = true;
                this.loading = false;
                setTimeout(() => {
                    this.password = '';
                    this.login = '';
                }, 500);
                setTimeout(() => {
                    this.error = false;
                }, 3000)
            })
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/authentication/component/login/login.component.ts